// extracted by mini-css-extract-plugin
export var legendIndicator = "_9r-1";
export var legendRight = "_9r-0";